// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grayTitle[data-v-30d3381a]{\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 12px;\n  width: 50px;\n  color: #A8AEB8;\n  margin-top: -7px;\n}\n", ""]);
// Exports
module.exports = exports;
